import { render } from "./NoMenuAccess.vue?vue&type=template&id=0b44100e&scoped=true"
import script from "./NoMenuAccess.vue?vue&type=script&lang=js"
export * from "./NoMenuAccess.vue?vue&type=script&lang=js"

import "./NoMenuAccess.vue?vue&type=style&index=0&id=0b44100e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b44100e"]])

export default __exports__